import styled, { css } from 'styled-components';
import { getSpace } from '../../../foundation/theme/space.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// styled-components.
// -----------------------------------------------------------------------------
export const TabsContentsRoot = styled.div `
  ${({ mode, type }) => css `
    /* Color */
    background-color: transparent;

    ${type === 'boxed' &&
    `
      border: 1px solid ${tokens.colors.midnight[mode === 'light' ? 800 : 200].value};
      color: ${tokens.colors.midnight[mode === 'light' ? 800 : 200].value};
      padding: ${getSpace('l')};
    `}

    ${type !== 'boxed' &&
    `
      margin-top: ${getSpace('xl')};
    `}
  `}
`;
//# sourceMappingURL=TabsContents.styled.js.map